var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-viewport",class:[_vm.loaded],style:(_vm.viewportStyles)},[_vm._t("default",null,{"dimm":_vm.dimm})],2)}
var staticRenderFns = []

export { render, staticRenderFns }